import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core';
import FlagstoneTheme from '../../Config/flagstoneTheme';
import Drawer from '@material-ui/core/Drawer';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import clsx from 'clsx';
import { drawerWidth, drawerClosedWidth, helpFilesTypes } from '../../Config/constants';
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation } from 'react-router-dom';
import PDFDialog from '../Shared/Dialogs/PDFDialog';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import { scissorTypes, scissorStates } from '../../Config/scissorStates'
import { dataService } from '../../Services/data.service';
import { machine } from '../../Config/constants';

import { toast } from 'react-toastify';
import { connect } from 'react-redux';

export const NavDrawer = (props) => {
    const classes = useStyles();
    let history = useHistory();
    let location = useLocation();
    const [open, setOpen] = React.useState(false);
    const [page, setPage] = React.useState(location.pathname);
    const [helpFilesDialogOpen, setHelpFilesDialogOpen] = React.useState(false);
    const [workstations, setWorkstations] = useState([])
    const [activeWorkstationIds, setActiveWorkstationIds] = useState([])

    useEffect(() => {
        dataService.getMachinesByMachineType(machine).then(stations => {
            if (JSON.stringify(stations) !== JSON.stringify(workstations)) {
                setWorkstations(stations)
            }

        }).catch((error) => { toast.error(error, { position: toast.POSITION.TOP_CENTER }) })

        dataService.getMachinesWithScissorStatusInfo().then(workstationsWithScissorStatusses => {

            if (JSON.stringify(props.workstationState.workstationsWithScissorStatusInfo) !== JSON.stringify(workstationsWithScissorStatusses.sort((a, b) => a.id - b.id))) {
                props.actions.setWorkstationWithScissorStatusInfo(workstationsWithScissorStatusses.sort((a, b) => a.id - b.id))
            }

            let workstationIds = []
            var i;
            if (!props.workstation.noSelectedWorkstation) {
                if (props.workstation.activeWorkstations) {
                    for (i = 0; i < props.workstation.activeWorkstations.length; i++) {
                        workstationIds.push(props.workstation.activeWorkstations[i].id)
                    }
                }
            }

            setActiveWorkstationIds(workstationIds)

        }).catch((error) => { toast.error(error, { position: toast.POSITION.TOP_CENTER }) })
    }, [props.workstation.activeWorkstations]);

    const { t } = useTranslation();

    const toggleDrawer = () => {
        setOpen(!open);
    }

    const handleRedirect = (link) => {

        if (link === "/help") {
            setHelpFilesDialogOpen(true)
        } else {
            history.push(link);
            setPage(link);
        }
    }

    history.listen(event => {

        if (!event.pathname.includes('login')) {
            props.actions.setCurrentURL(event.pathname)
        }
        if (event.pathname.includes('dashboard')) {
            props.actions.setSmart("PRODUCTIVITY")
        }
        else {
            props.actions.setSmart("PRODUCTION")
        }

        if (event.pathname.includes("/workstation") || event.pathname.includes("/order") || event.pathname.includes("/qualitychecks") || event.pathname.includes("/sampling")) {
            if (event.pathname.includes("/workstation")) {
                props.actions.setSelectedZone(null)
            }
            if (!props.nav.showActiveLines) {
                props.actions.setShowActiveLines(true)
            }
        }
        else {
            if (props.nav.showActiveLines) {
                props.actions.setShowActiveLines(false)
            }
        }

        setPage(event.pathname);
    });

    const changeUpperScrap = () => {
        let tempMachineScissorStates = props.workstationState.workstationsWithScissorStatusInfo.slice();
        let upperScrap = false
        let machineId = props.workstation.selectedWorkstation ? props.workstation.selectedWorkstation : 1
        let machineLowerStatus = tempMachineScissorStates.find(x => x.id === machineId).scissorStatuses.find(x => x.scissorName === scissorTypes.LOWER)
        let machineUpperStatus = tempMachineScissorStates.find(x => x.id === machineId).scissorStatuses.find(x => x.scissorName === scissorTypes.UPPER)
        if (machineLowerStatus.name !== scissorStates.PLANNEDSTOP && machineLowerStatus.name !== scissorStates.UNPLANNEDSTOP) {
            if (machineUpperStatus.name === scissorStates.SCRAP) {
                machineUpperStatus.name = scissorStates.PRODUCTION
                machineUpperStatus.foregroundColorInHex = "#5CC958"
                machineUpperStatus.backgroundColorInHex = "#5CC9581A"
                machineUpperStatus.startedOn = new Date()
            }
            else {
                machineUpperStatus.name = scissorStates.SCRAP
                machineUpperStatus.foregroundColorInHex = "#F59127"
                machineUpperStatus.backgroundColorInHex = "#F591271A"
                machineUpperStatus.startedOn = new Date()
                upperScrap = true
            }
            props.actions.setUpdatedWorkstationId(machineId)
            props.actions.setWorkstationWithScissorStatusInfo(tempMachineScissorStates)
            dataService.changeMachineStatus(false,false, machineId, upperScrap, machineLowerStatus.name === scissorStates.SCRAP).then(
            ).catch((error) => { toast.error(error, { position: toast.POSITION.TOP_CENTER }) })
        }
    }

    const changeLowerScrap = () => {
        let tempMachineScissorStates = props.workstationState.workstationsWithScissorStatusInfo.slice();
        let lowerScrap = false
        let machineId = props.workstation.selectedWorkstation ? props.workstation.selectedWorkstation : 1
        let machineLowerStatus = tempMachineScissorStates.find(x => x.id === machineId).scissorStatuses.find(x => x.scissorName === scissorTypes.LOWER)
        let machineUpperStatus = tempMachineScissorStates.find(x => x.id === machineId).scissorStatuses.find(x => x.scissorName === scissorTypes.UPPER)
        if (machineLowerStatus.name !== scissorStates.PLANNEDSTOP && machineLowerStatus.name !== scissorStates.UNPLANNEDSTOP) {
            if (machineLowerStatus.name === scissorStates.SCRAP) {
                machineLowerStatus.name = scissorStates.PRODUCTION
                machineLowerStatus.foregroundColorInHex = "#5CC958"
                machineLowerStatus.backgroundColorInHex = "#5CC9581A"
                machineLowerStatus.startedOn = new Date()
            }
            else {
                machineLowerStatus.name = scissorStates.SCRAP
                machineLowerStatus.foregroundColorInHex = "#F59127"
                machineLowerStatus.backgroundColorInHex = "#F591271A"
                machineLowerStatus.startedOn = new Date()
                lowerScrap = true
            }
            props.actions.setUpdatedWorkstationId(machineId)
            props.actions.setWorkstationWithScissorStatusInfo(tempMachineScissorStates)
            dataService.changeMachineStatus(false, false,machineId, machineUpperStatus.name === scissorStates.SCRAP, lowerScrap).then().catch((error) => { toast.error(error, { position: toast.POSITION.TOP_CENTER }) })
        }
    }

    const changeMachineStatus = () => {

        let tempMachineScissorStates = props.workstationState.workstationsWithScissorStatusInfo.slice();
        let stopMachine = true
        let machineId = props.workstation.selectedWorkstation ? props.workstation.selectedWorkstation : 1
        let machineLowerStatus = tempMachineScissorStates.find(x => x.id === machineId).scissorStatuses.find(x => x.scissorName === scissorTypes.LOWER)
        let machineUpperStatus = tempMachineScissorStates.find(x => x.id === machineId).scissorStatuses.find(x => x.scissorName === scissorTypes.UPPER)
        if (machineLowerStatus.name === scissorStates.PLANNEDSTOP || machineLowerStatus.name === scissorStates.UNPLANNEDSTOP) {
            stopMachine = false
            machineLowerStatus.name = scissorStates.PRODUCTION
            machineUpperStatus.name = scissorStates.PRODUCTION
            machineLowerStatus.foregroundColorInHex = "#5CC958"
            machineUpperStatus.foregroundColorInHex = "#5CC958"
            machineLowerStatus.backgroundColorInHex = "#5CC9581A"
            machineUpperStatus.backgroundColorInHex = "#5CC9581A"
            machineUpperStatus.startedOn = new Date()
        }
        else {
            machineLowerStatus.name = scissorStates.PLANNEDSTOP
            machineUpperStatus.name = scissorStates.PLANNEDSTOP
            machineLowerStatus.foregroundColorInHex = "#4654FB"
            machineUpperStatus.foregroundColorInHex = "#4654FB"
            machineLowerStatus.backgroundColorInHex = "#4654FB1A"
            machineUpperStatus.backgroundColorInHex = "#4654FB1A"
            machineUpperStatus.startedOn = new Date()
            props.actions.setBreakdownDetectedDialogOpen(true)
        }
        props.actions.setUpdatedWorkstationId(machineId)
        props.actions.setWorkstationWithScissorStatusInfo(tempMachineScissorStates)

        dataService.changeMachineStatus(stopMachine,stopMachine, machineId, false, false).then().catch((error) => { toast.error(error, { position: toast.POSITION.TOP_CENTER }) })
    }

    return (
        <Drawer
            variant="permanent"
            className={clsx(classes.drawer, {
                [classes.drawerOpen]: open,
                [classes.drawerClose]: !open,
            })}
            classes={{
                paper: clsx({
                    [classes.drawerOpen]: open,
                    [classes.drawerClose]: !open,
                }),
            }}
        >
            <React.Fragment>
                <div className={classes.toolbar}>
                    <IconButton onClick={toggleDrawer}>
                        <img className={classes.menuIcon} alt="menu" src={process.env.PUBLIC_URL + '/img/menu.svg'}></img>
                    </IconButton>
                </div>
                <Divider />
                <List className={classes.list}>
                    <ListItem className={clsx({ [classes.activeList]: page === "/" })} style={{ paddingLeft: "13px" }} button key="workstations" onClick={() => handleRedirect("/")}>
                        <ListItemIcon className={clsx({ [classes.activeText]: page === "/" })}><svg xmlns="http://www.w3.org/2000/svg" width="20.182" height="20.324" viewBox="0 0 20.182 20.324"><defs></defs><path className={clsx({ [classes.activeHomeIcon]: page === "/" })} fill="none" stroke="#020100" fillRule="evenodd" d="M19.182,18.864V8.682a1.224,1.224,0,0,0-.455-1.091l-8-7a1.507,1.507,0,0,0-1.909,0L.545,7.682A1.3,1.3,0,0,0,0,8.773V18.864a.648.648,0,0,0,.727.636H5.818a.648.648,0,0,0,.727-.636V13.773a2.347,2.347,0,0,1,2.364-2.364h1.364a2.293,2.293,0,0,1,2.364,2.364v5.091a.7.7,0,0,0,.727.636h5.182A.621.621,0,0,0,19.182,18.864Z" transform="translate(0.5 0.324)" /></svg></ListItemIcon>
                        <ListItemText className={clsx({ [classes.activeText]: page === "/" })} primary={t('Workstations')} style={{ fontFamily: "Lato, sans-serif", fontSize: "16px" }} />
                    </ListItem>
                    <ListItem className={clsx({ [classes.activeList]: page.includes("/workstation") || page.includes("/order") || page.includes("/qualitychecks") })} style={{ paddingLeft: "11px" }} button disabled={activeWorkstationIds.length === 0 ? true : false}  key="overview" onClick={() => handleRedirect("/workstation")}>
                        <ListItemIcon className={clsx({ [classes.activeText]: page.includes("/workstation") || page.includes("/order") || page.includes("/qualitychecks") })} ><svg xmlns="http://www.w3.org/2000/svg" width="26.329" height="26.329" viewBox="0 0 26.329 26.329"><defs></defs><g transform="translate(-48.368 -48.366)"><g transform="translate(48.518 48.516)"><g transform="translate(0 0)"><path className={clsx({ [classes.activeProductionIcon]: page.includes("/workstation") || page.includes("/order") || page.includes("/qualitychecks") })} fill="#020100" stroke="#020100" strokeWidth="0.3px" d="M62.746,74.545H60.318a1.518,1.518,0,0,1-1.505-1.39l-.125-1.565a10.384,10.384,0,0,1-2.258-.938l-1.194,1.02a1.51,1.51,0,0,1-2.049-.08l-1.718-1.718a1.518,1.518,0,0,1-.082-2.047l1.02-1.2a10.406,10.406,0,0,1-.935-2.254l-1.565-.125a1.518,1.518,0,0,1-1.39-1.505V60.316a1.518,1.518,0,0,1,1.389-1.505l1.565-.125a10.382,10.382,0,0,1,.934-2.261l-1.017-1.19a1.518,1.518,0,0,1,.08-2.049l1.718-1.718a1.51,1.51,0,0,1,2.047-.082L56.43,52.4a10.409,10.409,0,0,1,2.258-.931l.125-1.565a1.518,1.518,0,0,1,1.505-1.389h2.428a1.518,1.518,0,0,1,1.505,1.389l.125,1.565a10.412,10.412,0,0,1,2.258.931l1.195-1.017a1.51,1.51,0,0,1,2.047.082l1.718,1.718a1.517,1.517,0,0,1,.08,2.049l-1.017,1.19a10.386,10.386,0,0,1,.934,2.261l1.565.125a1.518,1.518,0,0,1,1.39,1.505v2.428a1.518,1.518,0,0,1-1.39,1.505l-1.565.125a10.4,10.4,0,0,1-.935,2.254l1.02,1.2a1.518,1.518,0,0,1-.082,2.047l-1.718,1.718a1.51,1.51,0,0,1-2.049.08l-1.194-1.02a10.371,10.371,0,0,1-2.258.938l-.125,1.565A1.518,1.518,0,0,1,62.746,74.545Zm-6.358-4.728a.375.375,0,0,1,.192.053,9.632,9.632,0,0,0,2.554,1.061.376.376,0,0,1,.283.335l.147,1.83a.762.762,0,0,0,.755.7h2.428a.762.762,0,0,0,.755-.7l.147-1.83a.376.376,0,0,1,.283-.335,9.622,9.622,0,0,0,2.554-1.06.377.377,0,0,1,.437.037l1.4,1.193a.758.758,0,0,0,1.028-.04l1.718-1.718a.762.762,0,0,0,.041-1.027l-1.192-1.4a.376.376,0,0,1-.037-.436,9.657,9.657,0,0,0,1.057-2.551.376.376,0,0,1,.335-.283L73.1,63.5a.762.762,0,0,0,.7-.755V60.316a.762.762,0,0,0-.7-.755l-1.83-.147a.376.376,0,0,1-.335-.283,9.634,9.634,0,0,0-1.057-2.557.376.376,0,0,1,.037-.437l1.19-1.393a.761.761,0,0,0-.04-1.028L69.344,52a.757.757,0,0,0-1.027-.041l-1.4,1.189a.376.376,0,0,1-.436.037A9.66,9.66,0,0,0,63.93,52.13a.376.376,0,0,1-.283-.335l-.147-1.83a.762.762,0,0,0-.755-.7H60.318a.761.761,0,0,0-.755.7l-.147,1.83a.376.376,0,0,1-.283.335,9.662,9.662,0,0,0-2.554,1.054.376.376,0,0,1-.436-.037l-1.4-1.189A.757.757,0,0,0,53.721,52L52,53.717a.761.761,0,0,0-.04,1.028l1.19,1.392a.376.376,0,0,1,.037.437,9.636,9.636,0,0,0-1.057,2.557.376.376,0,0,1-.335.283l-1.83.147a.762.762,0,0,0-.7.755v2.428a.762.762,0,0,0,.7.755l1.83.147a.376.376,0,0,1,.335.283,9.657,9.657,0,0,0,1.057,2.551.376.376,0,0,1-.037.436l-1.192,1.4A.761.761,0,0,0,52,69.342l1.718,1.718a.757.757,0,0,0,1.028.04l1.4-1.193A.377.377,0,0,1,56.388,69.817Z" transform="translate(-48.518 -48.516)" /></g><g transform="translate(10.986 10.986)"><path className={clsx({ [classes.activeProductionIcon]: page.includes("/workstation") || page.includes("/order") || page.includes("/qualitychecks") })} fill="#020100" stroke="#020100" strokeWidth="0.3px" d="M225.694,227.718a2.025,2.025,0,1,1,1.436-.594A2.017,2.017,0,0,1,225.694,227.718Zm0-3.3a1.272,1.272,0,1,0,.9.372A1.267,1.267,0,0,0,225.694,224.415Z" transform="translate(-223.666 -223.662)" /></g><g transform="translate(5.668 9.753)"><path className={clsx({ [classes.activeProductionIcon]: page.includes("/workstation") || page.includes("/order") || page.includes("/qualitychecks") })} fill="#020100" stroke="#020100" strokeWidth="0.3px" d="M139.266,207.887a.376.376,0,0,1-.376-.363,7.427,7.427,0,0,1,.649-3.3.376.376,0,1,1,.686.31,6.67,6.67,0,0,0-.583,2.968.376.376,0,0,1-.363.389Z" transform="translate(-138.886 -203.998)" /></g><g transform="translate(7.709 5.668)"><path className={clsx({ [classes.activeProductionIcon]: page.includes("/workstation") || page.includes("/order") || page.includes("/qualitychecks") })} fill="#020100" stroke="#020100" strokeWidth="0.3px" d="M171.794,141.659a.376.376,0,0,1-.266-.642,7.373,7.373,0,0,1,5.459-2.14.376.376,0,1,1-.027.752,6.614,6.614,0,0,0-4.9,1.92A.375.375,0,0,1,171.794,141.659Z" transform="translate(-171.418 -138.872)" /></g><g transform="translate(10.175 17.567)"><path className={clsx({ [classes.activeProductionIcon]: page.includes("/workstation") || page.includes("/order") || page.includes("/qualitychecks") })} fill="#020100" stroke="#020100" strokeWidth="0.3px" d="M213.564,331.373a7.365,7.365,0,0,1-2.588-.469.376.376,0,0,1,.264-.7,6.628,6.628,0,0,0,7-1.508.376.376,0,0,1,.532.532A7.368,7.368,0,0,1,213.564,331.373Z" transform="translate(-210.732 -328.581)" /></g><g transform="translate(13.806 7.049)"><path className={clsx({ [classes.activeProductionIcon]: page.includes("/workstation") || page.includes("/order") || page.includes("/qualitychecks") })} fill="#020100" stroke="#020100" strokeWidth="0.3px" d="M269,166.064a.376.376,0,0,1-.266-.642L273.154,161a.376.376,0,1,1,.532.532l-4.419,4.419A.375.375,0,0,1,269,166.064Z" transform="translate(-268.624 -160.892)" /></g><g transform="translate(9.798 14.145)"><path className={clsx({ [classes.activeProductionIcon]: page.includes("/workstation") || page.includes("/order") || page.includes("/qualitychecks") })} fill="#020100" stroke="#020100" strokeWidth="0.3px" d="M205.108,276.111a.376.376,0,0,1-.266-.642l1.331-1.331a.376.376,0,1,1,.532.532L205.374,276A.375.375,0,0,1,205.108,276.111Z" transform="translate(-204.732 -274.027)" /></g></g></g></svg></ListItemIcon>
                        <ListItemText className={clsx({ [classes.activeText]: page.includes("/workstation") || page.includes("/order") || page.includes("/qualitychecks") })} primary={t('Production')} style={{ fontFamily: "Lato, sans-serif", fontSize: "16px" }} />
                    </ListItem>
                    <ListItem className={clsx({ [classes.activeList]: page.includes("/dashboard") })} style={{ paddingLeft: "13px" }} button key="dashboardoverview" onClick={() => handleRedirect("/dashboardoverview")}>
                        <ListItemIcon className={clsx({ [classes.activeText]: page.includes("/dashboard") })}><svg xmlns="http://www.w3.org/2000/svg" width="21.7" height="19.648" viewBox="0 0 21.7 19.648"><defs></defs><g transform="translate(-14.035 -17.482)"><path className={clsx({ [classes.activeIcon]: page.includes("/dashboard") })} fill="#020100" stroke="#fff" strokeWidth="0.4px" d="M24.885,17.682a10.6,10.6,0,0,0-7.53,3.125,10.722,10.722,0,0,0,0,15.121,10.316,10.316,0,0,0,.973.859.732.732,0,0,0,1.006-.135,6.871,6.871,0,0,1,11.1,0,.732.732,0,0,0,1.006.135,10.353,10.353,0,0,0,.973-.859,10.686,10.686,0,0,0-7.531-18.246Zm0,1.423a9.165,9.165,0,0,1,6.524,2.712,9.268,9.268,0,0,1,0,13.1c-.118.118-.243.211-.361.32a8.126,8.126,0,0,0-12.327,0c-.117-.109-.243-.2-.361-.32a9.268,9.268,0,0,1,0-13.1,9.165,9.165,0,0,1,6.524-2.713Zm5.006,3.513a.715.715,0,0,0-.487.211l-3.094,3.1a2.846,2.846,0,1,0,1.417,2.451,2.871,2.871,0,0,0-.4-1.449l3.086-3.091a.711.711,0,0,0,.159-.792.728.728,0,0,0-.679-.43Zm-5.006,4.338a1.428,1.428,0,1,1-1.417,1.424,1.408,1.408,0,0,1,1.417-1.424Z" transform="translate(0 0)" /></g></svg></ListItemIcon>
                        <ListItemText className={clsx({ [classes.activeText]: page.includes("/dashboard") })} primary={t('Dashboard')} style={{ fontFamily: "Lato, sans-serif", fontSize: "16px" }} />
                    </ListItem>
                    <ListItem style={{ paddingLeft: "13px", position: "absolute", bottom: "0" }} button key="help" onClick={() => handleRedirect("/help")}>
                        <ListItemIcon ><svg xmlns="http://www.w3.org/2000/svg" width="23.881" height="23.881" viewBox="0 0 23.881 23.881"><defs></defs><g transform="translate(-2 -2)"><path fill="#020100" d="M13.94,17.083a1.257,1.257,0,1,1-1.257,1.257A1.257,1.257,0,0,1,13.94,17.083Zm.628-1.634a.628.628,0,0,1-1.257,0V14.8a1.634,1.634,0,0,1,1.171-1.564,1.886,1.886,0,0,0,1.343-1.806A1.925,1.925,0,0,0,13.94,9.541a1.886,1.886,0,0,0-1.885,1.885.628.628,0,1,1-1.257,0A3.143,3.143,0,0,1,13.94,8.284a3.181,3.181,0,0,1,3.142,3.142,3.143,3.143,0,0,1-2.239,3.01.377.377,0,0,0-.275.36ZM24.624,13.94A10.684,10.684,0,1,0,13.94,24.624,10.683,10.683,0,0,0,24.624,13.94Zm1.257,0A11.94,11.94,0,1,1,13.94,2,11.94,11.94,0,0,1,25.881,13.94Z" /></g></svg></ListItemIcon>
                        <ListItemText primary={t('Help')} style={{ fontFamily: "Lato, sans-serif", fontSize: "16px" }} />
                    </ListItem>
                    <button className={classes.configButton1}  key="changeUpperScrap" onClick={() => changeUpperScrap()}>
                        <ArrowUpwardIcon className={classes.arrow}></ArrowUpwardIcon>
                    </button>
                    <button className={classes.configButton2}  key="changeLowerScrap" onClick={() => changeLowerScrap()}>
                        <ArrowDownwardIcon className={classes.arrow}></ArrowDownwardIcon>
                    </button>
                    <button className={classes.configButton3}  key="changeMachineStatus" onClick={() => changeMachineStatus()}>
                        <img className={classes.machine} alt="machine" src={process.env.PUBLIC_URL + '/img/machineIcon.png'}></img>
                    </button>
                    <ListItem className={clsx({ [classes.activeList]: page === "/planning" })} style={{ paddingLeft: "13px" }} button key="planning" onClick={() => handleRedirect("/planning")}>
                        <ListItemIcon className={clsx({ [classes.activeText]: page === "/planning" })}><svg xmlns="http://www.w3.org/2000/svg" width="23.996" height="24.44" viewBox="0 0 23.996 24.44"><defs></defs><path className={clsx({ [classes.activeIcon]: page.includes("/planning") })} fill="#020100" d="M7.911,1.62A5.417,5.417,0,0,0,2.5,7.031V20.206a5.417,5.417,0,0,0,5.411,5.411h7.476a.444.444,0,0,0,0-.889H7.911a4.526,4.526,0,0,1-4.522-4.522V7.031A4.526,4.526,0,0,1,7.911,2.509H21.086a4.526,4.526,0,0,1,4.522,4.522V15.4a.444.444,0,0,0,.889,0V7.031A5.417,5.417,0,0,0,21.086,1.62Zm3.411,3.111a.44.44,0,0,0-.3.154L8.242,8.125l-1.7-1.273a.444.444,0,1,0-.533.71L8.043,9.085a.444.444,0,0,0,.6-.067l3.047-3.555a.444.444,0,0,0-.371-.732ZM14.5,6.953a.444.444,0,1,0,0,.889h8a.444.444,0,1,0,0-.889Zm-3.177,4a.442.442,0,0,0-.3.154L8.242,14.346l-1.7-1.273a.444.444,0,1,0-.533.71l2.032,1.524a.444.444,0,0,0,.6-.067l3.047-3.555a.444.444,0,0,0-.371-.732ZM14.5,13.174a.444.444,0,1,0,0,.889h8a.444.444,0,1,0,0-.889ZM21.164,15.4A5.332,5.332,0,1,0,26.5,20.728,5.338,5.338,0,0,0,21.164,15.4Zm0,.889a4.444,4.444,0,1,1-4.444,4.444A4.449,4.449,0,0,1,21.164,16.285Zm0,1.333a.444.444,0,0,0-.444.444v2.666a.444.444,0,0,0,.444.444H23.83a.444.444,0,1,0,0-.889H21.608V18.062A.444.444,0,0,0,21.164,17.618Zm-9.842,0a.44.44,0,0,0-.3.154L8.242,21.011l-1.7-1.273a.444.444,0,0,0-.533.71l2.032,1.524a.444.444,0,0,0,.6-.067l3.047-3.554a.444.444,0,0,0-.371-.732Z" transform="translate(-2.5 -1.62)" /></svg></ListItemIcon>
                        <ListItemText className={clsx({ [classes.activeText]: page === "/planning" })} primary={t('Planning')} style={{ fontFamily: "Lato, sans-serif", fontSize: "16px" }} />
                    </ListItem>
                </List>
                <PDFDialog {...props} dialogOpen={helpFilesDialogOpen} closeDialog={() => setHelpFilesDialogOpen(false)}></PDFDialog>
            </React.Fragment>
        </Drawer>
    )
}

const useStyles = makeStyles((theme) => ({
    spacer80: {
        height: '80px'
    },

    gridmargin: {
        paddingRight: "50px !important"
    },

    workstation: {
        height: "100px",
        margin: "20px",
        fontSize: "20pt",
        textAlign: "center",
        fontWeight: "bold",
        color: FlagstoneTheme.primaryColor,
        textDecoration: 'none'
    },

    navButton: {
        textDecoration: 'none'
    },

    background: {
        height: '100vh',
        width: '100%'
    },

    drawer: {
        width: drawerWidth,
        flexShrink: 0,
        whiteSpace: 'nowrap',
    },
    drawerOpen: {
        width: drawerWidth,
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    drawerClose: {
        width: drawerClosedWidth,
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        overflowX: 'hidden'
    },

    activeList: {
        backgroundColor: FlagstoneTheme.palette.primary.main,
        '&:hover': {
            backgroundColor: FlagstoneTheme.palette.primary.main,
        }
    },

    activeText: {
        color: FlagstoneTheme.palette.secondary.main,
        '&:hover': {
            color: "white",
        }
    },
    activeIcon: {
        fill: "white",
    },
    activeHomeIcon: {
        stroke: "white"
    },
    activeProductionIcon: {
        fill: "white",
        stroke: "white",
        strokeWidth: "0.3px"
    },
    list: {
        height: "100%"
    },
    arrow: {
        color: "#E5E5E5"
    },
    configButton1: {
        backgroundColor: "rgb(1,1,1,0)",
        paddingLeft: "13px",
        position: "absolute",
        bottom: "150",
        border: "none",
        outline: "none",
        cursor: "pointer"
    },
    configButton2: {
        backgroundColor: "rgb(1,1,1,0)",
        paddingLeft: "13px",
        position: "absolute",
        bottom: "100",
        border: "none",
        outline: "none",
        cursor: "pointer"
    },
    configButton3: {
        backgroundColor: "rgb(1,1,1,0)",
        paddingLeft: "10px",
        position: "absolute",
        bottom: "50",
        border: "none",
        outline: "none",
        cursor: "pointer",
    },
    machine: {
        height: "30px",
    }


}));

function mapStateToProps(state) {
    return {
        workstationState: state.workstationState,
        general: state.general
    }
}

export default connect(mapStateToProps)(NavDrawer)